module.exports = __webpack_public_path__ + "img/play.8028238b.svg";